import { useEffect, useMemo, useState } from 'react';
import { usePagination } from './usePagination';

interface PaginatedDataConfig {
  pageSize: number;
  initialPage?: number;
}

export const usePaginatedData = <T>(
  originalData: T[],
  { pageSize, initialPage = 1 }: PaginatedDataConfig,
): {
  page: number;
  data: T[];
  onPageChange: (page: number) => void;
  totalPages: number;
} => {
  const totalPages = useMemo(() => Math.ceil(originalData.length / pageSize), [originalData, pageSize]);

  const [page, onPageChange] = usePagination({ totalPages, initialPage });

  const [data, setData] = useState<T[]>(originalData);

  useEffect(() => {
    setData(originalData.slice((page - 1) * pageSize, page * pageSize));
  }, [originalData, page, pageSize]);

  return {
    page,
    data,
    onPageChange,
    totalPages,
  };
};
